import {useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
//import Grid from '@mui/material/Grid';
import { Button, Card, CardContent, CardMedia, Grid, IconButton, Pagination, Typography } from '@mui/material';
import { BiX } from "react-icons/bi";
import ProviderPopover from './tech_directory/ProviderPopover';
import parse from 'html-react-parser';

function ProjectPopover(props) {
    const [position, setPosition] = useState({
        top: window.innerHeight * 0.1,
        left: window.innerWidth * 0.1,
    });
    const [page, setPage] = useState(1);
    const [ selectedProvider, setSelectedProvider ] = useState(null);
    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const updatePosition = () => {
        setPosition({
        top: window.innerHeight * 0.1,
        left: window.innerWidth * 0.1,
        });
    };

    useEffect(() => {
        window.addEventListener('resize', updatePosition);
        return () => {
        window.removeEventListener('resize', updatePosition);
        };
    }, []);

    const handleClose = () => {
        props.setActiveResult(null);
    };

    const getOrganisationName = (id) => {
        if (props.organisations && props.organisations.length > 0) {
            let org = props.organisations.find(o => o.id === id);
            if (org) {
                return org.name;
            }
        }
        return "";
    };

    const getTechProviderName = (id) => {
        if (props.techProviders && props.techProviders.length > 0) {
            let tp = props.techProviders.find(o => o.id === id);
            if (tp) {
                return tp.name;
            }
        }
        return "";
    };

    const getTechProvider = (id) => {
        if (props.techProviders && props.techProviders.length > 0) {
            let tp = props.techProviders.find(o => o.id === id);
            if (tp) {
                return tp;
            }
        }
        return null;
    };

    const handleApproval = async () => {
        const { error } = await props.db
            .schema('api')
			.from('projects')
            .update({ approved: true })
            .eq('id', props.activeResult.id)

        if (props.setRefreshList) {
            props.setRefreshList(true);
        }

        props.setActiveResult(null);
    };

    const providerClicked = (e, i) => {
        e.preventDefault();
        setSelectedProvider(getTechProvider(i));
    }

    return (
        <Popover 
        open={Boolean(props.activeResult)}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={{ top: position.top, left: position.left }}
        slotProps={{
          paper: {
            sx: {
              width: '80vw',   // 80% of viewport width
              backgroundColor: '#F1F1F1',
            },
          },
        }}
      >
        {props.activeResult && 
    <Grid container spacing={2} sx={{padding:2}}>
        <Grid size={12} >
            <Box sx={{width:'100%'}}>
                <IconButton
                    size="large"
                    color="inherit"
                    onClick={() => handleClose()}
                    sx={{float: 'right'}}
                >
                <BiX />
                </IconButton>
            </Box>
        </Grid>
        <Grid size={{xs:12, sm:6, md:6, lg:6 }}>
            <Card sx={{ display: "flex", flexDirection: 'column', width: '100%', height: '100%', boxShadow: '5px 5px 5px 5px rgba(0, 0, 0, 0.25)', borderRadius: 0 }}>
                <CardContent sx={{ padding: 1, height: "100%", overflow: "hidden"}}>
                    <Typography variant="h5">
                        Technology Project: {props.activeResult.project_name}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                        Lead Organisation:{<br/>}
                    </Typography>
                    <Typography variant="body1">
                        {getOrganisationName(props.activeResult.owner)}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                        Timeframe:{<br/>}
                    </Typography>
                    <Typography variant="body1">
                        {props.activeResult.started} to {props.activeResult.ended}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                        SAFET Theme:{<br/>}
                    </Typography>
                    <Typography variant="body1" >
                        {props.activeResult.safet_theme.join(", ")}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                        Technology Providers:{<br/>}
                    </Typography>
                        <Typography variant="body1" component={'span'}>
                            <ul style={{marginTop: 0, marginBottom: 1}}>
                            {Array.from(props.activeResult.tech_providers, (i) => (<li key={'tp1'+i.id}><a href="#" onClick={(e) => providerClicked(e, i)}>{getTechProviderName(i)}</a></li>))}
                            </ul>
                        </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                        Project Stage:{<br/>}
                    </Typography>
                    <Typography variant="body1">
                        {props.activeResult.project_stage}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                        Geographic Area:{<br/>}
                    </Typography>
                    <Typography variant="body1">
                        {props.activeResult.project_country}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                        Technologies Used:{<br/>}
                    </Typography>
                    <Typography variant="body1">
                        {props.activeResult.technology_types.join(", ")}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                        Project Impact:{<br/>}
                    </Typography>
                    <Typography variant="body1">
                        {props.activeResult.project_impact}
                    </Typography>
                </CardContent>
            </Card>
        </Grid>
        <Grid size={{xs:12, sm:6, md:6, lg:6 }}>
            <Card sx={{ display: "flex", flexDirection: 'column', width: '100%', height: '100%', boxShadow: '5px 5px 5px 5px rgba(0, 0, 0, 0.25)', borderRadius: 0 }}>
                <CardContent sx={{ padding: 1, height: "100%", overflow: "hidden"}}>
                    {props.activeResult.image_urls && props.activeResult.image_urls.length > 0 &&
                    <div>
                    <CardMedia
                        component="img"
                        sx={{ maxHeight: "50vh", objectFit: "contain" }}
                        image={props.activeResult.image_urls[page-1]}
                        alt="Project image"
                    />
                    {props.activeResult.image_urls.length > 1 &&
                    <Pagination count={props.activeResult.image_urls.length} page={page} onChange={handlePageChange} />}
                    </div>}
                </CardContent>
            </Card>
        </Grid>
        <Grid size={{xs:12, sm:6, md:6, lg:6 }}>
            <Card sx={{ display: "flex", flexDirection: 'column', width: '100%', height: '100%', boxShadow: '5px 5px 5px 5px rgba(0, 0, 0, 0.25)', borderRadius: 0 }}>
                <CardContent sx={{ padding: 1, height: "100%", overflow: "hidden"}}>
                <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                    Project Description:{<br/>}
                </Typography>
                <Typography variant="body1">
                    {parse(props.activeResult.project_description)}
                </Typography>
                </CardContent>
            </Card>
        </Grid>
        <Grid size={{xs:12, sm:6, md:6, lg:6 }}>
            <Card sx={{ display: "flex", flexDirection: 'column', width: '100%', height: '100%', boxShadow: '5px 5px 5px 5px rgba(0, 0, 0, 0.25)', borderRadius: 0 }}>
                <CardContent sx={{ padding: 1, height: "100%", overflow: "hidden"}}>
                    <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                        Project Website:{<br/>}
                    </Typography>
                    <Typography variant="body1">
                        <a href={props.activeResult.website_link} target='_blank' rel='noreferrer'>{props.activeResult.website_link}</a>
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                        Publications, reports, and other links:{<br/>}
                    </Typography>
                    {props.activeResult.documents ? props.activeResult.documents.map((doc) => (
                    <Typography variant="body1" key={doc.name}>
                        <a href={doc.link} target='_blank' rel='noreferrer'>{doc.name}</a>
                    </Typography>
                    )) : 
                    <Typography variant="body1">
                        None
                    </Typography>
                    }
                </CardContent>
            </Card>
        </Grid>
        </Grid>
        }
        {props.admin === true && (
            <Button onClick={handleApproval} variant="contained" size="small">Approve</Button>
        )}

        <ProviderPopover {...{ activeResult: selectedProvider, setActiveResult: setSelectedProvider, techProviders: props.techProviders }} />

      </Popover>
    );
}

export default ProjectPopover;